import React from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import imageBorder from "../../assets/images/bestsellerborder.webp";
// import founder1 from "../../assets/images/founder1.webp";
import foundercard from "../../assets/images/foundercardbg.webp";
import foundercard2 from "../../assets/images/foundercardbg2.webp";
import founder1 from "../../assets/images/founder-1.webp";
import founder2 from "../../assets/images/founder-2.webp";

export const Founder = () => {
  return (
    <div className="founder-bg pb-5">
      <Container>
        <Row className="founder-row">
          <h1 className="text-center founder-heading-2 mt-3 saree-heading them-font">Founders</h1>
          <div className="d-flex justify-content-center">
            <img
              src={imageBorder}
              className="border-image border-image-founder pb-2 pt-1"
              alt="border"
              loading="lazy"
            />
          </div>
          <div className="d-flex justify-content-center pb-3 pb-lg-5 pb-md-5 pt-3">
            <p className="text-center">
              We are able to maintain the highest quality standards in our
              clothing line since our company has implemented a whole quality
              management approach. We also buy fabric and other supplies from
              vendors who are authorized by the business and who are well-versed
              in it. We are able to satisfy both our consumers and other
              retailers by putting into practice a quality-focused management
              strategy.
            </p>
          </div>
          <Col lg={6} md={12} sm={12} xs={12} className="p-3">
            <Card
              className="founder-card"
              style={{
                backgroundImage: `url(${foundercard})`,
              }}
            >
              <div className="row founder-data no-gutters">
                <div className="col-md-4 position-reletive">
                  <Card.Img
                    src={founder1}
                    className="position-absolute founder1-img"
                    alt="founder1-img"
                    loading="lazy"
                  />
                </div>
                <div className="col-md-8 custom-founder-col">
                  <Card.Body className="founder1-body">
                    <div className="text-start about-founder-para founder1-text my-8 them-font">
                      "Hello! I'm Ritesh Modi, and I'm incredibly proud to lead
                      Kesaria Textile Company. For us, clothing isn't just about
                      fabric and thread; it's about the people who wear it, the
                      stories it tells, and the confidence it inspires."
                    </div>
                    <div className="ceoimage">
                      <p className="founde1-font founder-head fs-2 fw-bold them-font">
                        Ritesh Modi
                      </p>
                      <button className="btn-red-to-black-color-move rounded-4 founder-btn founder-btn-button">
                        <span className="d-flex founder-btn-text">Founder & CEO</span>
                      </button>
                    </div>
                  </Card.Body>
                </div>
              </div>
            </Card>
          </Col>
          <Col lg={6} md={12} sm={12} xs={12} className="p-3">
            <Card
              className="founder-card"
              style={{
                backgroundImage: `url(${foundercard2})`,
              }}
            >
              <div className="row founder-data no-gutters">
                <div className="col-md-4 position-reletive">
                  <Card.Img
                    src={founder2}
                    className="position-absolute founder2-img"
                    alt="founder1-img"
                    loading="lazy"
                  />
                </div>
                <div className="col-md-8 custom-founder-col">
                  <Card.Body className="founder1-body founder2-body">
                    {/* <p className="text-start them-font">
                      As a Founder and CEO of Kesaria Textile Company, I
                      consider quality and innovation as our success targets and
                      would like to express my gratitude to everyone who gave
                      their passion to us.
                    </p> */}
                    <p className="text-start about-founder-para founder2-text them-font">
                      "As a CEO I am proud to be a part of Surat's thriving
                      textile industry and look forward to partnering with you.
                      Thank you for choosing Kesaria Textile Company."
                    </p>
                    <div className="ceoimage">
                      <p className="founde2-font fs-2 fw-bold them-font">
                        Vatsal Jain
                      </p>
                      {/* <button className="border-0 p-2 rounded-4 fs-6 fs-bold textwhite-color them-bg them-font">
                        <span>Founder & CEO</span>
                      </button> */}

                      <button className="btn-red-to-black-color-move rounded-4 founder-btn founder-btn-button founder-head">
                        <span className="d-flex founder-btn-text">Founder & CEO</span>
                      </button>
                    </div>
                  </Card.Body>
                </div>
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
